<template>
  <div v-if="isPromo" class="form-check form-group d-flex flex-column save-card-promo" dir="rtl">
    <input type="hidden" :id="name + 'notselected'" :name="name" :value="offValue()" />
    <div class="save-card-promo-box d-flex flex-row align-items-center">
      <input class="red-checkbox" type="checkbox" :value="onValue()" :id="name" :name="name" v-model="isChecked" :required="field.required" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid" :aria-required="fieldAriaRequired" @change="$emit('change')">
      <div class="save-card-promo-text d-flex flex-column">
        <label class="save-card-promo-label" :for="name">{{label}}</label>
        <span v-if="field.description" class="save-card-promo-description">{{field.description}}</span>
      </div>
    </div>
    <div class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
  <!-- TEMP demo: oval on every plain checkbox. Revert this class and the checkbox-oval-demo styles. -->
  <div v-else class="form-check form-group d-flex flex-column checkbox-oval-demo" dir="rtl">
    <input type="hidden" :id="name + 'notselected'" :name="name" :value="offValue()" />
    <div class="d-flex flex-row align-items-center checkbox-oval-demo-row">
      <input class="red-checkbox" type="checkbox" :value="onValue()" :id="name" :name="name" v-model="isChecked" :required="field.required" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid" :aria-required="fieldAriaRequired" @change="$emit('change')">
      <label class="f16-l23-m" :for="name" v-html="label">
      </label>
    </div>
    <div class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
</template>
<script>
import formFieldA11y from '@/mixins/formFieldA11y.js'

export default {
  mixins: [formFieldA11y],
  props: {
    label: String,
    type: String,
    name: String,
    value: Number,
    field: Object
  },
  data() {
    return {
      isChecked: this.value == 1
    }
  },
  watch: {
    value(next) {
      this.isChecked = next == 1;
    }
  },
  computed: {
    isPromo() {
      return this.field && this.field.highlighted === true;
    }
  },
  methods: {
    offValue() {
      if (this.field.boolean) return "false";
      return "0";
    },
    onValue() {
      if (this.field.boolean) return "true";
      return this.value;
    }
  }
  
}
</script>
<style scoped>
.save-card-promo-box {
  width: 100%;
  border: 2px solid #ef3d49;
  border-radius: 12px;
  padding: 14px 16px;
  box-sizing: border-box;
}
.save-card-promo-text {
  margin-inline-end: 12px;
}
.save-card-promo-label {
  font-weight: bold;
  font-size: 16px;
  line-height: 23px;
  margin: 0;
}
.save-card-promo-description {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #555;
  margin-top: 4px;
}
/* TEMP demo: same egg as .formfield-round-border .form-group-border-bottom. Revert with the template class. */
.checkbox-oval-demo.form-check {
  padding-left: 0;
  padding-right: 0;
}
.checkbox-oval-demo-row {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #DFDFDF;
  border-radius: 21px;
  padding: 8px 14px;
}
.checkbox-oval-demo-row label {
  margin: 0;
}
</style>
